// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// MODULES
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
import Avatar from 'components/common/Avatar';
// ANTD
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Icon from 'antd/lib/icon';
import 'antd/lib/icon/style/css';
import Dropdown from 'antd/lib/dropdown';
// STYLES
// import '/imports/ui/layouts/app/index.less';
// COMPONENTS
import DropdownMenu from './DropdownMenu';
import logo from 'lib/media/heyned-logo.svg';

const s = {
  centerCol: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rightCol: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarStyles: {
    position: 'relative',
    top: 0,
    right: 0,
  },
  logo: {
    maxHeight: 25,
    maxWidth: 164,
  },
};

const DropdownWrapper = styled.div`
  .anticon .anticon-user {
    font-size: 20px !important;
  }
`;

class AppHeader extends React.Component {
  render() {
    const {
      collapsed, currentUser, onToggleCollapse, sliderPadding,
    } = this.props;

    return (
      <Row type="flex" align="middle" justify="center" gutter={20}>
        <Col xs={17}>
          {' '}
          <img src={logo} alt="heyned-logo" style={s.logo} />
        </Col>
        <Col xs={5}>
          <Dropdown
            overlay={<DropdownMenu user={currentUser} />}
            trigger={['click']} // <React.Fragment>
          >
            <div>
              <Icon type="menu" style={{ fontSize: 30, margin: 24 }} />{' '}
            </div>
          </Dropdown>
        </Col>
      </Row>
    );
  }
}

AppHeader.defaultProps = {
  collapsed: false,
  sliderPadding: 10,
  onToggleCollapse: () => {},
};

export default AppHeader;



// WEBPACK FOOTER //
// ./src/components/layout/AppLayout/MobileHeader/index.js